export const parseData = (data: Array<any>) => {
  return data.map((item: any) => ({
    name: item.name,
    isActive: item.isActive && "Aktywny",
    id: item.id,
  }));
};
